// ESCROW SERVICE DISABLED
// import { useState, useEffect } from 'react';
// import { ordersAPI } from '../services/api';
// import '../assets/css/escrow-analytics.css';

/* ORIGINAL ESCROW COMPONENT COMMENTED OUT:
const EscrowAnalytics = ({ fetchOrders }) => {
  // ... full component body omitted for brevity, kept in git history ...
  // Original included: analytics state, fetchAnalytics, calculateAnalyticsFromOrders,
  // formatCurrency, formatPercentage, and full JSX return with summary grid,
  // status distribution chart, average processing time, and recent activity.
};

const getActivityIcon = (type) => {
  switch (type) {
    case 'held': return 'fa-lock';
    case 'released': return 'fa-check-circle';
    case 'refunded': return 'fa-undo';
    case 'disputed': return 'fa-exclamation-triangle';
    default: return 'fa-circle';
  }
};

const formatTimeAgo = (dateString) => {
  if (!dateString) return '';
  const now = new Date();
  const date = new Date(dateString);
  const diffInSeconds = Math.floor((now - date) / 1000);
  if (diffInSeconds < 60) return 'Just now';
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
  if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d ago`;
  return date.toLocaleDateString();
};
*/

const EscrowAnalytics = () => null;

export default EscrowAnalytics;
